var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-button"},[[_vm._t("btn",function(){return [_c('custom-button',{attrs:{"type":"primary","plain":""}},[_c('span',[_vm._v("Button")])])]})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }